import React, { Component, createRef } from 'react';
import Message from './ValidationMessage';
import InlineField from './InlineField';
import $ from 'jquery';

export class DropdownField extends Component {
  constructor(props) {
    super(props);
    this.dd = createRef();
  }

  componentDidMount() {
    $(this.dd.current).dropdown({
      forceSelection: false,
      clearable: true,
    });
  }

  componentDidUpdate(prevProps) {
    const { input: { value: prevValue } } = prevProps;
    const { input: { value: currValue } } = this.props;

    if (!currValue) {
      $(this.dd.current).dropdown('clear');
      return;
    }

    if (prevValue !== currValue) {
      $(this.dd.current).dropdown('set selected', currValue);
    }
  }

  componentWillUnmount() {
    $(this.dd.current).dropdown('destroy');
  }

  render() {
    let {
      intl,
      translation,
      input,
      required,
      placeholder,
      label,
      list = [],
      activeOnly = true,
      id,
      idField = 'id',
      displayField = 'name',
      displayField2 = null,
      displayType = 'edit',
      disabled = false,
      link = false,
      search = true,
      className,
      hideDefaultMsg,
      textStyle,
      meta: { touched, error, warning },
    } = this.props;

    let content;
    let showError = touched && error ? 'error' : '';

    const requiredClass = required ? 'required' : '';
    const disabledClass = disabled ? 'disabled' : '';
    const name = input ? input.name : '';

    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(
          placeholderObj.message,
          placeholderObj.params
        );
      }
    }

    const optionList = list.reduce((accumulator = [], item, index) => {
      if (item) {
        const idVal = item[idField];
        if (idVal != null) {
          const optionValue = idVal;
          const optionLabel =
            displayField2 === null
              ? item[displayField]
              : `${item[displayField2]}: ${item[displayField]}`;

          if (input.value === optionValue) {
            content = optionLabel;
          }

          if (activeOnly) {
            if (!item.hasOwnProperty('active') || item.active) {
              accumulator.push(
                <option key={index} value={optionValue}>
                  {optionLabel}
                </option>
              );
            }
          } else {
            accumulator.push(
              <option key={index} value={optionValue}>
                {optionLabel}
              </option>
            );
          }
        }
      }

      return accumulator;
    }, []);

    if (displayType === 'inline') {
      return (
        <InlineField
          fieldType="renderDropdownField"
          link={link}
          docType={(list[0] || {}).doc_type}
          value={input.value}
          content={content}
          label={label}
          id={id}
        />
      );
    }

    const searchOption = search ? 'search' : '';

    return (
      <div className={`${requiredClass} ${disabledClass} field ${showError}`} style={{ ...textStyle }}>
        {label && <label>{label}</label>}
        <select
          {...input}
          ref={this.dd}
          className={`ui ${searchOption} ${
            className || ''
          } compact dropdown renderDropdown ${name}`}
          id={id}
          name={name}
          placeholder={placeholder}
        >
          {!hideDefaultMsg &&
            (placeholder ? (
              <option value="">{placeholder}</option>
            ) : (
              <option value=""></option>
            ))}
          {optionList && optionList};
        </select>
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }
}
